import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ListGroup, Offcanvas } from 'react-bootstrap';
import { RightArrow } from './../../../assets/icons/RightArrow';
import { logoutLearner } from '../../../redux/slice/authSlice';
import { resetAllState } from '../../../redux/slice/rootSlice';
import { Routers } from '../../../routes/Constant';
import './DashboardLeftSide.css';
import { message } from 'antd';

export const DashboardLeftSide = ({ isDirty,profileConfirmHanlder }) => {
  const dispatch = useDispatch();
  const pathname = useLocation().pathname;
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const logoutHandler = () => {
    dispatch(logoutLearner());
    dispatch(resetAllState());
    localStorage.clear();
    localStorage.removeItem('persist:root');
    message.success({
      content: "You Logout Successfully",
      duration: 2,
    });
  };

  useEffect(() => {
  }, [isDirty]);

  const handleNavigation = (to) => (event) => {
    if (isDirty) {
      profileConfirmHanlder(false)
      const confirmLeave = window.confirm(
        "You have unsaved changes, are you sure you want to leave this page?"
      );
      if (!confirmLeave) {
        event.preventDefault();
        return;
      }
    }
    navigate(to);
    handleClose();
  };

  const renderLink = (to, label) => (
    <ListGroup.Item>
      <Link
        to={to}
        onClick={handleNavigation(to)}
        className={`dashBoard_list_name ${
          pathname === to ? 'dashBoard_focus' : 'dashBoard_list_name'
        }`}
      >
        {label}
      </Link>
    </ListGroup.Item>
  );

  return (
    <>
      <div className="resp_side_bar">
        <h5 onClick={handleShow} className="dash_menu">
          Dashboard Menu <span className="ps-2"><RightArrow /></span>
        </h5>
        <Offcanvas show={show} onHide={handleClose}>
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <section className="">
              <div className="dashboard_list para_text">
                <ListGroup variant="flush">
                  {renderLink(Routers.Home, 'Home')}
                  {renderLink(Routers.Dashboard, 'Dashboard')}
                  {renderLink(Routers.Profile, 'Profile')}
                  {renderLink(Routers.ChangePassword, 'Change Password')}
                  {renderLink(Routers.Booking, 'Bookings')}
                  {renderLink(Routers.Transaction, 'Transaction History')}
                  {renderLink(Routers.Wallet, 'Wallet')}
                  <ListGroup.Item>
                    <Link
                      onClick={logoutHandler}
                      to={Routers.Login}
                      className={`dashBoard_list_name ${
                        pathname === Routers.Logout ? 'dashBoard_focus' : 'dashBoard_list_name'
                      }`}
                    >
                      Logout
                    </Link>
                  </ListGroup.Item>
                </ListGroup>
              </div>
            </section>
          </Offcanvas.Body>
        </Offcanvas>
      </div>

      <section className="dashboard_leftside_wrapper">
        <div className="dashboard_list para_text">
          <ListGroup variant="flush">
            {renderLink(Routers.Home, 'Home')}
            {renderLink(Routers.Dashboard, 'Dashboard')}
            {renderLink(Routers.Profile, 'Profile')}
            {renderLink(Routers.ChangePassword, 'Change Password')}
            {renderLink(Routers.Booking, 'Bookings')}
            {renderLink(Routers.Transaction, 'Transaction History')}
            {renderLink(Routers.Wallet, 'Wallet')}
            <ListGroup.Item>
              <Link
                to={Routers.Home}
                onClick={logoutHandler}
                className={`dashBoard_list_name ${
                  pathname === Routers.Home ? 'dashBoard_focus' : 'dashBoard_list_name'
                }`}
              >
                Logout
              </Link>
            </ListGroup.Item>
          </ListGroup>
        </div>
      </section>
    </>
  );
};
